import { Suspense, useState } from 'react';
import { Box } from '@mui/material';
import LazyConfetti from './LazyConfetti';
import { getCelebrationOrigin, useCelebration } from './celebrate';
import { prefersReducedMotion } from './useCanvasAnimation';

/** New Year's: a confetti burst from the bind-in-progress message each time a policy binds. */
export const BindConfetti = () => {
  const [runKey, setRunKey] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [origin, setOrigin] = useState(getCelebrationOrigin);

  useCelebration('bind', () => {
    if (prefersReducedMotion()) return;
    setOrigin(getCelebrationOrigin());
    setRunKey((key) => key + 1);
    setIsRunning(true);
  });

  if (!isRunning) return null;

  return (
    <Box sx={sxStyles.container}>
      <Suspense fallback={null}>
        <LazyConfetti
          key={runKey}
          recycle={false}
          numberOfPieces={250}
          gravity={0.25}
          // a tight source plus a strong upward kick reads as an explosion rather than a curtain
          confettiSource={{ x: origin.x - 20, y: origin.y, w: 40, h: 10 }}
          initialVelocityX={12}
          initialVelocityY={{ min: -18, max: -6 }}
          onConfettiComplete={() => setIsRunning(false)}
        />
      </Suspense>
    </Box>
  );
};

const sxStyles = {
  container: {
    position: 'fixed',
    inset: 0,
    pointerEvents: 'none',
    zIndex: 1250,
  },
};
